const RESOLUTION_BREAKPOINT = {
  small: 480,
  medium: 769,
  large: 1023,
  extraLarge: 1440
};

export default RESOLUTION_BREAKPOINT;
